export default __webpack_public_path__ + "static/media/yeasin.30be67ec.png";